﻿import { Component, OnInit } from '@angular/core';
import { PagerService } from '../..//./services/pager.service';
import { HttpService } from '../..//./services/http.service';
import { PermissionModel } from "./..//../models/permission.model";
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
function _window(): any {
    return window;
}

@Component({
    selector: 'mails',
    templateUrl: './mails.component.html',
    providers: [PagerService, HttpService]
})
export class MailsComponent implements OnInit {
    api: any = { Search: "mail/search", Delete: "mail/delete", Save: "/mail/save", Edit: "/mail", Bulk: "/bulk-mail" };
    columns: any;
    header: string = "Mails";
    isLoader: boolean = false;
    type: string = "";
    constructor(public http: HttpService, public pagerService: PagerService, public router: Router, public toastr: ToastrService) {
        this.columns = [
            { Name: "Name", Header: "Name", DataType: "string" },
            { Name: "Email", Header: "Email", DataType: "string" },
            { Name: "Subject", Header: "Subject", DataType: "string" },
            { Name: "Body", Header: "Body", DataType: "string" },
            { Name: "UpdatedOn", Header: "Updated On", DataType: "string" }
        ];
        this.isLoader = true;
    }

    ngOnInit(): void {
        this.loadData();
    }
    get window(): any {
        return _window();
    }

    //datatable
    id: number = 0;
    isDelete: boolean = false;
    searchString: string = "";
    permission: PermissionModel = new PermissionModel();

    pagerSize: number = 10;
    start: number = 1;
    end: number = this.pagerSize + this.start - 1;
    data: any[] = [];
    keys: any[] = [];
    pageNo: number = 1;
    pager: any = {};
    dataCount: number = 0;
    pagerSizes: any[] = [
        { "Text": "5", "Value": 5 }, { "Text": "10", "Value": 10 }, { "Text": "25", "Value": 25 }, { "Text": "50", "Value": 50 }, { "Text": "All", "Value": 0 }
    ];
    orderBy: any = "Id";
    isDescending: boolean = true;
    changePager(): void {
        this.pageNo = 1;
        this.loadData();
    }

    loadData(): void {
        this.start = (this.pageNo - 1) * this.pagerSize;
        this.end = this.pageNo * this.pagerSize;
        let objSearch = {
            SearchString: this.searchString, RecordsPerPage: this.pagerSize, OrderBy: this.orderBy, IsDecending: this.isDescending, PageNo: this.pageNo, Message: this.type
        };
        this.isLoader = true;
        this.http.post("" + this.api.Search, objSearch).subscribe(result => {
            this.permission = result.json().Permissions;
            this.isLoader = false;
            if (this.permission.isView) {
                this.data = result.json().List;
                this.dataCount = result.json().NoOfRecords;
                this.pager = this.pagerService.getPager(this.dataCount, this.pageNo, this.pagerSize);
                this.isLoader = false;
            }
            else {
                this.router.navigateByUrl("/unauthorized");
            }

        }, error => {
            this.isLoader = false;
            this.http.validateAuth(error);
        });

    }


    sort(column: string) {
        if (this.orderBy == column) {
            this.isDescending = !this.isDescending;
        }
        else {
            this.isDescending = false;
        }
        this.orderBy = column;
        this.pageNo = 1;
        this.loadData();
    }

    setPage(page: number) {
        this.pageNo = page;
        this.loadData();

    }

    search() {
        this.pageNo = 1;
        this.loadData();
    }

    send(Id: number) {
        this.http.post("" + this.api.Save, { "Id": Id }).subscribe(result => {
            if (result.json().IsFailure) {
                this.toastr.error('Failed!', result.json().Message);
            }
            else {
                this.toastr.success('Success!', "Successfully sent!");
                this.loadData();
            }
        }, error => {
            console.error(error);
        });
    }
    deleteConfirm(Id: number) {
        this.id = Id;
        this.isDelete = true;
    }
    delete() {
        this.http.post("" + this.api.Delete, { "Id": this.id }).subscribe(result => {
            this.closeModal();
            this.loadData();
        }, error => {
            console.error(error);
        });
    }
    

    closeModal() {
        this.isDelete = false;
        this.id = 0;
    }
    edit() {
        this.router.navigateByUrl(this.api.Edit);
    }
    bulk() {
        this.router.navigateByUrl(this.api.Bulk);
    }
}